export default __webpack_public_path__ + "static/media/spinner.5dd05a10.svg";